// src/pages/income/env/disinfection/IncomeEnvDisinfectionDraftNew.jsx
// ✅ 환경/소독 "수입데이터+기안 작성" 페이지 — 얇은 래퍼.
import React from "react";
import IncomeDraftNew from "../../_shared/IncomeDraftNew";
import incomeEnvDisinfectionDraftConfig from "./incomeEnvDisinfectionDraftConfig";

export default function IncomeEnvDisinfectionDraftNew() {
  return <IncomeDraftNew config={incomeEnvDisinfectionDraftConfig} />;
}
